import { Injectable } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { CommandService, Flow, HasCommands } from "../../command/command.service";
import { CommandInput, CommandTemplate } from "../../../entities/commandTemplate/commandTemplate";
import { EditDialogService } from "../../../components/editDialog/editDialogService";
import { LabelDialogComponent } from "../../../components/label-dialog/label-dialog.component";

@Injectable({
    providedIn: 'root'
  })
export class LabelUpdateCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      this.dialogRef = this.dialogService.open(LabelDialogComponent, {
        width: "500px",
        header: "Label bearbeiten",
        data: {
          commandTemplate: commandTemplate,
        }
      });
      this.dialogRef.onClose.subscribe((result) => {
        if(result){
          commandInput.addParameter("labelInput", result);
          commandService.sendCommand(commandInput, () => {
            completionCallback();
          })
        }
      });

    }
  }
